<template>
  <div class="border">
    <h4 v-b-toggle="'collapse-comisiones'+indice" class="text-primary m-2" style="cursor: pointer;">
        Comisiones      
    </h4>
    <b-collapse :id="'collapse-comisiones'+indice" v-model="visible" @show="mostrar">
      <div class="card-body" v-for="(registro, index) in registros" :key="index">
        <!--b-table style="table-layout: fixed;" :items="registros" :fields="['tipo_agente', 'cod_agente',	'nombre',	'porcentaje', 'comision_moneda', 'comision_pesificada']">
        
        </b-table-->  
        <p><b class="text-primary">Tipo de Agente: </b>{{registro.tipo_agente}}</p>  
        <p><b class="text-primary">Código de Agente: </b>{{registro.cod_agente}}</p>  
		    <p><b class="text-primary">Nombre: </b>{{registro.nombre}}</p>  
		    <p><b class="text-primary">Porcentaje: </b>{{registro.porcentaje}}</p>  
		    <p><b class="text-primary">Comisión: </b>{{registro.comision_moneda}}</p>  
		    <p v-if="registro.comision_moneda!=registro.comision_pesificada"><b class="text-primary">Comisión Pesificada: </b>{{registro.comision_pesificada}}</p>  
        <hr>
      </div>
    </b-collapse>
    
  </div>
</template>

<script>
export default {
    props: {
      estado: false,
      nroPoliza: {
        type: Number | String
      },
      nroEndoso: {
        type: Number | String
      },
      indice: 0      
    },
    data(){
      return {
        registros: [],
        cambiado: false,
        visible: true
      }
    },
    methods:{
      mostrar(){
          let userauth = JSON.parse(sessionStorage.getItem('auth'));
          let rolUsuario = userauth.role.roles[0].id;  
                   
          //console.log('mostrado');
            if (this.cambiado){            
              let loading = this.$loading.show();            
              //console.log('polizas/comisiones/'+this.nroPoliza+'/'+this.nroEndoso+'/'+rolUsuario);
              this.enviando = true;
              this.$api('polizas/comisiones/'+this.nroPoliza+'/'+this.nroEndoso+'/'+rolUsuario)
                  .then(res => {
                    this.registros = res.data;
                    loading.hide();
                    this.cambiado = false;                    
                  });
            }
      }
    },
    /*mounted() {
      this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
          let userauth = JSON.parse(sessionStorage.getItem('auth'));
          let rolUsuario = userauth.role.roles[0].id;           
          //console.log(collapseId);
            if (collapseId == 'collapse-comisiones' && isJustShown && this.cambiado){            
              let loading = this.$loading.show();            
              //console.log('polizas/comisiones/'+this.nroPoliza+'/'+this.nroEndoso+'/'+rolUsuario);
              this.enviando = true;
              this.$api('polizas/comisiones/'+this.nroPoliza+'/'+this.nroEndoso+'/'+rolUsuario)
                  .then(res => {
                    this.registros = res.data;
                    loading.hide();
                    this.cambiado = false;                    
                  });
            }
        })
    },*/
    watch:{
       nroEndoso: {
         handler: function(newVal, oldVal){
          this.cambiado = newVal != oldVal && newVal != undefined;
          this.visible = !this.cambiado;          
       },
        deep: true,
        inmediate: false
       },
       estado:{
         handler: function(newVal, oldVal){
            this.visible = this.estado;    
         }
       }
    }

}
</script>
